import axios from 'axios'

export default {
    getPlateList({commit}, params){
        return axios.post('/api/background/plate/list', params)
    },
    addPlate({commit}, params){
        return axios.post('/api/background/plate/add', params)
    },
    modifyPlate({commit}, params){
        return axios.post('/api/background/plate/modify', params)
    },
    deletePlate({commit}, params){
        return axios.post('/api/background/plate/delete', params)
    },
    getPlateTypeList({commit}, params){
        return axios.post('/api/background/plate_type/list', params)
    },
    addPlateType({commit}, params){
        return axios.post('/api/background/plate_type/add', params)
    },
    modifyPlateType({commit}, params){
        return axios.post('/api/background/plate_type/modify', params)
    },
    deletePlateType({commit}, params){
        return axios.post('/api/background/plate_type/delete', params)
    },
}


// WEBPACK FOOTER //
// ./src/vuex/actions/plate.js